import { PermissionMapping } from '@@/lib/permissions';

//i.e reader/writer/business-user = token passed to page component to handle page permissions
//i.e Array of permissions = a permission the user might have which would grant the key's level of access

export type InsightsPermission = 'reader' | 'writer' | 'admin';

const permissionSetMapping: PermissionMapping<InsightsPermission>['permissionSetMapping'] = {
  reader: ['pronetx-insights'],
  writer: ['pronetx-insights']
};

export const insightsPermissionMapping: PermissionMapping<InsightsPermission>[] = [
  {
    permissionSetMapping,
    urlSignature: '/contact-visualizer',
    showInNavbar: true,
    label: 'Flow Visualizer'
  }
];
